import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "22", y1: "11", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "7", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "17", y2: "17.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BatteryWarning";
const BatteryWarning = memo(themed(Icon));
export {
  BatteryWarning
};
//# sourceMappingURL=battery-warning.js.map
